/* eslint-disable no-unused-vars */

import { recordMark } from '@stitch-fix/client-analytics-reporter';
import { sendLog } from '../../utils/sendMetrics';
import { useGetShopProductsPriceAndInventoryQuery } from './getShopProductsPriceAndInventory';
import mockedResponse from './useShopProductQueryPriceAndInventory.mockedResponse';

const useShopProductQueryPriceAndInventory = ({
  productSkuId,
  externalProductId,
}) => {
  const {
    data: shopProductPriceAndInventoryData,
    loading: shopProductPriceAndInventoryLoading,
    error: shopProductPriceAndInventoryError,
  } = useGetShopProductsPriceAndInventoryQuery({
    skip: !(productSkuId || externalProductId),
    variables: {
      skuId: productSkuId || '',
      externalProductId: externalProductId || '',
      useExternalProductID: !productSkuId,
    },
    onCompleted: () => {
      recordMark(
        'get_shop_products_price_and_inventory_graph_query_completed',
        {
          graph_query_succeeded: true,
        },
      );
    },
    onError: () => {
      recordMark(
        'get_shop_products_price_and_inventory_graph_query_completed',
        {
          graph_query_succeeded: false,
        },
      );

      sendLog(
        `GetShopProductsPriceAndInventory error for sku ID ${productSkuId}: ${shopProductPriceAndInventoryError}`,
        {
          sku_id: productSkuId,
          error_message: shopProductPriceAndInventoryError,
        },
      );
    },
  });

  if (window.gon.use_mock_graphql_data) {
    return {
      shopProductPriceAndInventoryData: mockedResponse.data,
      shopProductPriceAndInventoryLoading,
      shopProductPriceAndInventoryError,
    };
  }

  return {
    shopProductPriceAndInventoryData,
    shopProductPriceAndInventoryLoading,
    shopProductPriceAndInventoryError,
  };
};

export default useShopProductQueryPriceAndInventory;
